// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__diMqy","inner":"Header_inner__FEy9D","link":"Header_link__2Egsb","linkLabel":"Header_linkLabel__qe6lK"};